import { Button, Modal, ModalInner } from 'components';
import React, { Dispatch, SetStateAction } from 'react'

interface ModalProps {
  isOpened: boolean;
  setIsOpened: Dispatch<SetStateAction<boolean>>;
  onConfirm: () => void; // onConfirm 콜백 추가
  message: string;
}

const RegisterModal = ({ isOpened, setIsOpened, onConfirm, message  }: ModalProps) => {
  // 모달 닫기 함수
  function onCancel() {
    setIsOpened(false);
  }

  // 확인 버튼 클릭 시 처리할 함수
  function handleConfirm() {
    onConfirm(); // 부모 컴포넌트의 onConfirm 호출
  }
  
  return (
    <Modal isOpened={isOpened}>
      <ModalInner className="md:w-[500px]" title="Consent Required" onClickClose={onCancel}>
        <p className=" p-4 pt-0 text-body1">{message}</p>
        <div className="flex w-full flex-row items-center justify-between bg-bg-transparent_gray_light p-4">
          <Button className="h-9" text="Cancel" type="secondary" size="large" onClick={onCancel} />
          <Button className="h-9" text="Confirm" type="blue" size="large" onClick={onConfirm} />
        </div>
      </ModalInner>
    </Modal>
  )
}

export default RegisterModal;



